import React, { Fragment } from "react";

const NotFound = () => {
  return (
    <Fragment>
      <h1 className="nflead">404: Page Not Found :( </h1>
      <p className="nfp">Sorry, this page is under coding..</p>
    </Fragment>
  );
};

export default NotFound;
